import { MoreVertical } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Switch } from '@/components/ui/switch'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import type { Unit } from '@/types/api'
import type { CombinedColumnDef } from '@/api/dowload-excel.api'
import { formatDateTime } from '@/utils/format'

interface BuildColumnsOptions {
  pageIndex: number
  pageSize: number
  canView?: boolean
  canUpdate?: boolean
  canDelete?: boolean
  canResetPass?: boolean
  canConfigTheme?: boolean
  onViewDetail?: (unit: Unit) => void
  onUpdate?: (unit: Unit) => void
  onConfigTheme?: (unit: Unit) => void
  onDelete?: (unit: Unit) => void
  onToggleStatus?: (unit: Unit) => void
  onResetPassword?: (unit: Unit) => void
  onResendActivationMail?: (unit: Unit) => void
}

export function buildColumns({
  pageIndex,
  pageSize,
  canView = true,
  canUpdate = true,
  canDelete = true,
  canResetPass = true,
  canConfigTheme = true,
  onViewDetail,
  onUpdate,
  onConfigTheme,
  onDelete,
  onToggleStatus,
  onResetPassword,
  onResendActivationMail,
}: BuildColumnsOptions): CombinedColumnDef<Unit>[] {
  return [
    {
      id: 'stt',
      header: 'STT',
      size: 55,
      align: 'center',
      cell: ({ row }) => row.index + 1 + pageIndex * pageSize,
    },
    {
      accessorKey: 'code',
      header: 'MÃ ĐƠN VỊ',
      align: 'left',
    },
    {
      accessorKey: 'name',
      header: 'TÊN ĐƠN VỊ',
      align: 'left',
      cell: ({ row }) => (
        <button
          type="button"
          className="cursor-pointer text-[#CE7A58] hover:text-[#b8694a]"
          onClick={() => onViewDetail?.(row.original)}
        >
          {row.original.name}
        </button>
      ),
    },
    {
      accessorKey: 'updatedAt',
      header: 'NGÀY CẬP NHẬT',
      size: 130,
      align: 'center',
      cell: ({ getValue }) => formatDateTime(getValue()),
    },
    {
      accessorKey: 'status',
      header: 'TRẠNG THÁI',
      size: 110,
      align: 'center',
      cell: ({ row }) => {
        const unit = row.original

        return (
          <div className="flex justify-center">
            <Switch
              disabled={!canUpdate}
              checked={unit.status === 1}
              onCheckedChange={() => {
                if (!canUpdate) return
                onToggleStatus?.(unit)
              }}
            />
          </div>
        )
      },
    },
    {
      id: 'actions',
      size: 55,
      exportable: false,
      cell: ({ row }) => (
        <div className="flex justify-center">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="h-8 w-8">
                <MoreVertical />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-40">
              {canView && (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => onViewDetail?.(row.original)}
                >
                  Xem chi tiết
                </DropdownMenuItem>
              )}
              {canUpdate && (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => onUpdate?.(row.original)}
                >
                  Cập nhật
                </DropdownMenuItem>
              )}
              {canConfigTheme && (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => onConfigTheme?.(row.original)}
                >
                  Cấu hình giao diện
                </DropdownMenuItem>
              )}
              {row.original.activeStatus === 0 ? (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => onResendActivationMail?.(row.original)}
                >
                  Gửi lại mail kích hoạt
                </DropdownMenuItem>
              ) : canResetPass ? (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => onResetPassword?.(row.original)}
                >
                  Đặt lại mật khẩu mặc định
                </DropdownMenuItem>
              ) : null}
              {canDelete && (
                <DropdownMenuItem
                  className="cursor-pointer text-red-600 focus:text-red-600"
                  onClick={() => onDelete?.(row.original)}
                >
                  Xóa
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      ),
    },
  ]
}
